export default "__VITE_ASSET__CXusoyRx__"